import { Badge } from "@/components/ui/badge";

const MAP = {
  creado:       { label: "Creado",       cls: "bg-[#002FA7] text-white hover:bg-[#002FA7]" },
  fabricacion:  { label: "Fabricación",  cls: "bg-[#8B5CF6] text-white hover:bg-[#8B5CF6]" },
  empaque:      { label: "Empaque",      cls: "bg-[#F59E0B] text-white hover:bg-[#F59E0B]" },
  entrega:      { label: "Entrega",      cls: "bg-[#3B82F6] text-white hover:bg-[#3B82F6]" },
  facturado:    { label: "Facturado",    cls: "bg-[#64748B] text-white hover:bg-[#64748B]" },
  pagado:       { label: "Pagado",       cls: "bg-[#10B981] text-white hover:bg-[#10B981]" },
  cancelado:    { label: "Cancelado",    cls: "bg-[#FF2A2A] text-white hover:bg-[#FF2A2A]" },
  pendiente:    { label: "Pendiente",    cls: "bg-zinc-200 text-zinc-800 hover:bg-zinc-200" },
  en_proceso:   { label: "En proceso",   cls: "bg-amber-100 text-amber-900 hover:bg-amber-100" },
  listo:        { label: "Listo",        cls: "bg-emerald-100 text-emerald-900 hover:bg-emerald-100" },
  en_camino:    { label: "En camino",    cls: "bg-blue-100 text-blue-900 hover:bg-blue-100" },
  entregado:    { label: "Entregado",    cls: "bg-emerald-100 text-emerald-900 hover:bg-emerald-100" },
  fallido:      { label: "Fallido",      cls: "bg-red-100 text-red-900 hover:bg-red-100" },
};

export function StatusBadge({ status, className = "" }) {
  const v = MAP[status] || { label: status, cls: "bg-zinc-200 text-zinc-800" };
  return (
    <Badge className={`${v.cls} ${className} rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider`}>
      {v.label}
    </Badge>
  );
}
